import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import HttpClient from '../../services/HttpClient';
import { getUserToken } from '../../services/utils';

const http = new HttpClient();
const baseUrl = 'https://wallet.pishro-tech.ir/api/v1-test';
const initialState = {
	facilityStep: 0,
	walletToken: '4df19117a81ffe60bb4de1a9b8264200ec1f5ac3',
	isLoading: {
		backdrop: false,
		form: false,
		skeleton: false,
		button: false,
	},
	walletState: [],
	message: '',
	personalInfo: {
		fullName: '',
		birthDate: '',
		day: '',
		month: '',
		year: '',
		city: '',
		state: '',
		address: '',
		sabteAhval: null,
	},
	credit: {
		amount: 6000000,
		maxAmount: 20000000,
		minAmount: 2000000,
		amountStep: 500000,
		plan: 'bank_mehr',
	},
	tracking_code: '',
	bank_verify: {},
	validationState: false,
};

// getWallet
export const GetWallet = createAsyncThunk('home/wallet', async (params, thunkAPI) => {
	const token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {};
	const response = await http.post('GetWallets', param, extraConfig).then((res) => res.data);
	return response;
});
export const fetchLoanPlan = createAsyncThunk('wallet/fetchLoanPlan', async (params) => {
	const { sliderAmount, plan } = params;
	const response = await http
		.post(`${baseUrl}/loan_plan?token=${params.walletToken}`, {
			plan,
			amount: sliderAmount,
		})
		.then((res) => res.data);
	return response;
});

export const fetchPersonalInfo = createAsyncThunk('wallet/fetchPersonalInfo', async (params) => {
	const { day, month, year, state, city, address } = params.info;
	const { isValidCity } = params;
	const response = await http
		.post(`${baseUrl}/personal_info?token=${params.walletToken}`, {
			birthdate: `${year}/${month}/${day}`,
			state,
			city,
			address,
			isValidCity,
		})
		.then((res) => res.data);
	return response;
});

export const confirmRequest = createAsyncThunk('wallet/confirm', async (params) => {
	const response = await http.post(`${baseUrl}/confirm?token=${params.walletToken}`).then((res) => res.data);
	return response;
});

export const fetchBankVerify = createAsyncThunk('auth/fetchBankVerify', async (params) => {
	const response = await http.post(`${baseUrl}/bank_verify?token=${params}`).then((res) => res.data);
	return response;
});
export const fetchIpg = createAsyncThunk('credit/fetchIpg', async (params) => {
	const response = await http
		.post(`${baseUrl}/send_to_ipg?token=${params.walletToken}`)
		.then((res) => res.data);
	return response;
});

const walletSlice = createSlice({
	name: 'wallet',
	initialState,
	reducers: {
		setAmountCredit(state, action) {
			state.credit.amount = action.payload;
		},
		changeStep(state, action) {
			state.facilityStep = action.payload;
		},
		setSabteAhval(state, action) {
			state.personalInfo.sabteAhval = action.payload;
		},
		setValidationState(state, action) {
			state.validationState = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchLoanPlan.pending, () => {})
			.addCase(fetchLoanPlan.fulfilled, (state, action) => {
				const {
					Content: { loan_info },
					Success,
				} = action.payload;
				if (Success) {
					state.credit = { ...loan_info };
					state.facilityStep = 1;
				}
			})
			.addCase(fetchLoanPlan.rejected, () => {});
		builder
			.addCase(fetchPersonalInfo.pending, () => {})
			.addCase(fetchPersonalInfo.fulfilled, (state, action) => {
				const { Content } = action.payload;
				const { isValidCity } = action.meta.arg;
				if (isValidCity) {
					state.personalInfo.fullName = `${Content.name} ${Content.last_name}`;
					state.personalInfo.birthDate = Content.birthdate;
					state.personalInfo.state = Content.state;
					state.personalInfo.city = Content.city;
					// if(Content.sabt_ahval)
					state.personalInfo.sabteAhval = true;
					// else
					//    state.personalInfo.sabteAhval = false;
				}
			})
			.addCase(fetchPersonalInfo.rejected, () => {});
		builder
			.addCase(confirmRequest.pending, () => {})
			.addCase(confirmRequest.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					//  state.ipgUrl = Content.ipg_url;
					state.tracking_code = Content.tracking_code;
				}
			})
			.addCase(confirmRequest.rejected, () => {});
		builder
			.addCase(fetchBankVerify.pending, (state) => {
				state.status = 'pending';
			})
			.addCase(fetchBankVerify.fulfilled, (state, action) => {
				const {
					Content: { bank_verify },
					Success,
				} = action.payload;
				if (Success) {
					state.bank_verify = bank_verify;
				}
			})
			.addCase(fetchBankVerify.rejected, (state) => {
				state.status = 'error';
			});
		builder
			.addCase(fetchIpg.pending, () => {})
			.addCase(fetchIpg.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					window.location.href = Content.ipg_url;
				}
			})
			.addCase(fetchIpg.rejected, () => {});
		builder
			.addCase(GetWallet.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(GetWallet.fulfilled, (state, action) => {
				state.isLoading = false;
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.walletState = Content.sponsors;
				} else {
					state.message = Message;
				}
			})
			.addCase(GetWallet.rejected, (state) => {
				state.isLoading = false;
				state.message = 'خطا در برقراری ارتباط با سرور';
			});
	},
});

export const { setAmountCredit, changeStep, setSabteAhval, setValidationState } = walletSlice.actions;
export default walletSlice.reducer;
